import {simpleRequest} from "../apiConfigs/request";

export const fetchBusinessList = (query) => {
  return simpleRequest({
    url: `/public/businesses${query}`,
    method: 'GET'
  });
}
